import React from 'react';
import { CtaBlock } from '../CtaBlock';
import { deliverables } from '../../data/content';
export function Access() {
  return <section className="bg-ink-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-61" data-mp="1su50prksqo90">
      <div className="mx-auto max-w-5xl" data-id="element-62" data-mp="1eu3vy11euwo9">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light" data-id="element-63" data-mp="1ev5cgl174bdd">
          📲 Accesso immediato
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-64" data-mp="27hq0pcmdk7cp">
          Cosa riceverai immediatamente?
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-65" data-mp="2blo2xw6zxy9z">
          {deliverables.map(item => <li key={item.title} className="flex h-full flex-col rounded-2xl border border-ink-500 bg-ink-700 p-5" data-id="element-66" data-mp="22r9ofvuairrx">
              <span className="text-2xl" aria-hidden="true" data-id="element-67" data-mp="2qfswca9fh2jh">
                {item.icon}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold uppercase leading-tight text-arc-light" data-id="element-68" data-mp="2v9x42vqipelm">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-mute" data-id="element-69" data-mp="1y9i6dabqw8uk">{item.text}</p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-arc/40 bg-ink-900 p-6 sm:p-9" data-id="element-70" data-mp="2c1gbla2c5klg">
          <h3 className="text-center font-display text-2xl font-bold uppercase leading-tight text-bone sm:text-4xl" data-id="element-71" data-mp="278dfova35z23">
            La tua guida di riferimento per la saldatura, sempre con te
          </h3>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-mute sm:text-lg" data-id="element-72" data-mp="2gygexd7sw98v">
            Invece di guardare un altro video di 20 minuti ogni volta che hai un dubbio, apri
            semplicemente il manuale corrispondente, trova ciò che ti serve e torna al lavoro.
          </p>
          <p className="mt-5 text-center font-display text-xl font-bold uppercase text-arc-light sm:text-2xl" data-id="element-73" data-mp="10kymxw4zcm9d">
            Un sistema. Sei Manuali Maestri. Centinaia di soluzioni pratiche.
          </p>

          <div className="mt-8" data-id="element-74" data-mp="2vpzerj6rokr2">
            <CtaBlock data-id="element-75" data-mp="30mpqxvfgaw77" />
          </div>
        </div>
      </div>
    </section>;
}